import Moment from 'moment';
import isNumber from 'lodash/isNumber';
import moment from 'moment';

type TFormattedCurrency = {
  amount?: number;
  noDecimals?: boolean;
};

const FormattedCurrency = ({ amount, noDecimals }: TFormattedCurrency) => {
  let formatter = '';
  if (amount || amount === 0) {
    let decimals = 2;
    if (noDecimals) {
      decimals = 0;
    }
    formatter = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(amount);
  }

  return <>{formatter}</>;
};

type TFormattedPercent = {
  value?: number;
  maxDigits?: number;
};

const FormattedPercent = ({ value, maxDigits = 0 }: TFormattedPercent) => {
  let formatter = '';
  if (value || value === 0) {
    formatter = new Intl.NumberFormat('en-AU', {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: maxDigits
    }).format(value);
  }

  return <>{formatter}</>;
};

const FormattedNumber = ({
  value: _value = 0,
  maxDigits = 2
}: TFormattedPercent) => {
  let formatter = '';
  const containsPercent = String(_value).includes('%');
  const value = containsPercent ? String(_value).replace('%', '') : _value;
  const content = !isNumber(value) ? Number(value) : value;

  if (!isNaN(content)) {
    formatter = new Intl.NumberFormat('en-AU', {
      maximumFractionDigits: maxDigits
    }).format(content);
  }

  if (containsPercent) {
    formatter = formatter + '%';
  }

  return <>{formatter}</>;
};

type TFormattedDate = {
  date: string;
};

const allowedDateFormats = ['DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601];
const FormattedDate = ({ date }: TFormattedDate) => {
  const m = Moment(date, allowedDateFormats, true);
  return <>{Moment(date, allowedDateFormats, true).format('DD-MM-YYYY')}</>;
};

type TFormattedAddress = {
  address?: {
    streetNumber?: string;
    streetName?: string;
    suburb?: string;
    postCode?: string;
    state?: string;
    country?: string;
  };
};

const FormattedAddress = ({ address }: TFormattedAddress) => {
  return (
    <>
      {address && (
        <>
          {address.streetNumber} {address.streetName},<br />
          {address.suburb} {address.state} {address.postCode},<br />
          {address.country}
        </>
      )}
    </>
  );
};

type TFormattedMobile = {
  mobile: string;
};

const FormattedMobile = ({ mobile }: TFormattedMobile) => {
  return (
    <>
      {mobile.length <= 10 &&
        mobile.substring(0, 4) +
          ' ' +
          mobile.substring(4, 7) +
          ' ' +
          mobile.substring(7)}
      {mobile.length > 10 &&
        mobile.substring(0, 3) +
          ' ' +
          mobile.substring(3, 7) +
          ' ' +
          mobile.substring(7)}
    </>
  );
};

export {
  FormattedCurrency,
  FormattedDate,
  FormattedAddress,
  FormattedNumber,
  FormattedMobile,
  FormattedPercent
};
